import React, { useState } from 'react';
import { AppBar, Toolbar, Button, Box, Typography, Menu, MenuItem, useMediaQuery, IconButton } from '@mui/material';
import useHeaderStore from 'src/store/useHeaderStore';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from 'src/locales/languageSwitcher';
import logo_axeleratum from 'src/assets/logo_axeleratum.png';
import MenuIcon from '@mui/icons-material/Menu'; // Importar el icono de menú

const Header: React.FC = () => {
  const { t } = useTranslation();
  const setSelectedOption = useHeaderStore((state) => state.setSelectedOption);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const isSmallScreen = useMediaQuery('(max-width:1200px)');

  // Valores específicos para cada botón
  const headerOptions = [
    { label: `${t('HEADER_BUTTON_1')}`, value: 'home' },
    { label: `${t('HEADER_BUTTON_2')}`, value: 'solutions' },
    { label: `${t('HEADER_BUTTON_3')}`, value: 'projects' },
    { label: `${t('HEADER_BUTTON_4')}`, value: 'blog' },
    { label: `${t('HEADER_BUTTON_5')}`, value: 'contact' },
  ];

  const handleButtonClick = (value: string) => {
    setSelectedOption(value); // Envía el valor al estado
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget); // Abre el menú
    setOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setOpenMenu(false); // Cierra el menú
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" sx={{ backgroundColor: '#00171F' }}>
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {/* Logo */}
        <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
          <img src={logo_axeleratum} alt="logo" />
        </Typography>

        {/* Desktop Buttons */}
        {!isSmallScreen && (
          <Box
            sx={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: 2,
            }}
          >
            {headerOptions.map(({ label, value }) => (
              <Button
                key={value}
                sx={{ color: '#ffffff', textTransform: 'none', fontSize: '20px' }}
                onClick={() => handleButtonClick(value)}
              >
                {label}
              </Button>
            ))}
          </Box>
        )}

        {/* LanguageSwitcher */}
        <LanguageSwitcher />

        {/* Mobile Menu Button */}
        {isSmallScreen && (
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleMenuClick}
            sx={{ ml: 2 }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </Toolbar>

      {/* Mobile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'menu-button',
          autoFocus: true, // Asegura que el foco se coloque correctamente
        }}
        disableScrollLock // Evita problemas de bloqueo de foco relacionados con scroll
      >
        {headerOptions.map(({ label, value }) => (
          <MenuItem 
            key={value} 
            onClick={() => { 
              handleButtonClick(value); 
              handleCloseMenu(); 
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </AppBar>
  );
};

export default Header;
